// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePharmacyPhonesModel {
    static getAttributeTypeMap() {
        return SimpleIntakePharmacyPhonesModel.attributeTypeMap;
    }
}
SimpleIntakePharmacyPhonesModel.discriminator = undefined;
SimpleIntakePharmacyPhonesModel.additionalProperties = false;
SimpleIntakePharmacyPhonesModel.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "SimpleIntakePhoneModel"
    },
    {
        "name": "main",
        "baseName": "main",
        "type": "SimpleIntakePhoneModel"
    },
];
//# sourceMappingURL=simpleIntakePharmacyPhonesModel.js.map